export default __webpack_public_path__ + "static/media/esteban.9acb0b93.png";